import { EnvironmentTypes } from '@tribal-worldwide-london/fa-env';
import { Environment } from '@tribal-worldwide-london/fa-env';
import { Logger } from '@tribal-worldwide-london/fa-logger';

declare global {
  interface Window {
    tb: TribalGlobalInterface;
  }
}

interface TribalGlobalInterface {
  environment: EnvironmentTypes;
  logger: Logger;
}

// Initialise Environment.
const environment = new Environment();
const env = environment.get();

// Initialise Feature App Logger.
const logger = new Logger(
  import.meta.env.VITE_DEBUG,
  import.meta.env.VITE_LOG_LEVEL,
  import.meta.env.VITE_APP_NAME
);

/**
 * Config Manager, Content Manager & Analytics Driver are
 * Initiated in App.tsx.
 */

// Create Tribal Global Object.
const tb: TribalGlobalInterface = {
  environment: env,
  logger,
};

window.tb = tb;
